import {useEffect, useState} from "react";
import {logout} from "dataLayer/apisWithoutCache/slr/logout";
// import { destroyLocalStorageAuthUser } from "dataLayer/localStorage/localStorageMember";

import {IMember} from "../screens/AccountMembership/_private/types/midView";
import {LogoutCookies} from "utils/constants";
import {destroyCookie} from "utils/nookies";
import {destroyLocalStorageAuthUser} from "dataLayer/localStorage/localStorageMember";
import {CATEGORY_CHANGE_EVENT_NAME} from "./useGetCategory";

export function useLogoutCallback(callBack:(args:any)=>void) {

    useEffect(() => {
        document.addEventListener('on-logout-success',callBack)
        return () =>
            document.removeEventListener('on-logout-success', callBack);
    }, []);
}
